import React, { useRef, useEffect } from 'react';
import * as skinview3d from 'skinview3d';

// TODO: get react transform working
const Skinview3d = ({ className, width, height, skinUrl, capeUrl, enableOrbitControls = true, onReady, }) => {
    const canvasRef = useRef();
    const skinviewRef = useRef();
    useEffect(() => {
        const viewer = new skinview3d.SkinViewer({
            canvas: canvasRef.current,
            width: width,
            height: height,
        });
        if (enableOrbitControls) {
            const control = skinview3d.createOrbitControls(viewer);
            control.enableRotate = true;
            control.enableZoom = false;
            control.enablePan = false;
        }
        // @ts-ignore
        skinviewRef.current = viewer;
        // call onReady with the viewer instance
        if (onReady) {
            onReady(viewer);
        }
    }, []);
    // skin url changes
    useEffect(() => {
        if (!skinUrl) {
            return;
        }
        skinviewRef.current.loadSkin(skinUrl);
    }, [skinUrl]);
    // cape url changes
    useEffect(() => {
        if (!capeUrl) {
            return;
        }
        skinviewRef.current.loadCape(capeUrl);
    }, [capeUrl]);
    // size changes
    useEffect(() => {
        skinviewRef.current.width = width;
        skinviewRef.current.height = height;
    }, [width, height]);
    return (React.createElement("canvas", { className: className, ref: canvasRef, style: { imageRendering: "pixelated" } }));
};

export default Skinview3d;
//# sourceMappingURL=index.es.js.map
